import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Kotlin = () => {
  return (
    <StartInterviewLayout type="kotlin"/>
  )
}

export default Kotlin;